import React, { useEffect } from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";

function MenuItemTemplate({ text, icon }) {
  return (
    <>
      {icon && <span className="nk-menu-icon"><em className={`icon ni ni-${icon}`}></em></span>}
      {text && <span className="nk-menu-text">{text}</span>}
    </>
  );
}

function MenuItemLink({ text, icon, to }) {
  return <NavLink className="nk-menu-link" to={to}><MenuItemTemplate icon={icon} text={text} /></NavLink>;
}

function MenuItem({ className, ...props }) {
  const compClass = classNames({
    "nk-menu-item": true,
    [className]: className,
  });

  return <li className={compClass}>{props.children}</li>;
}

function MenuList({ className, ...props }) {
  const compClass = classNames({
    "nk-menu": true,
    [className]: className,
  });

  return <ul className={compClass}>{props.children}</ul>;
}

function MenuHeading({ className, text, ...props }) {
  const compClass = classNames({
    "nk-menu-heading": true,
    [className]: className,
  });

  return (
    <li className={compClass}>
      <h6 className="overline-title">{text || props.children}</h6>
    </li>
  );
}

function MenuFamily() {
  useEffect(() => {
    document.querySelectorAll(".nk-menu-link").forEach((item) => {
      if (item.classList.contains("active")) {
        item.parentElement?.classList.add("active", "current-page");
      }
    });
  }, []);

  return (
    <MenuList>
      <MenuHeading text="Family Portal" />
      <MenuItem>
        <MenuItemLink icon="home-fill" text="Portal Home" to="/family-portal" />
      </MenuItem>
      <MenuItem>
        <MenuItemLink icon="signout" text="Log Out" to="/auths/auth-logoff" />
      </MenuItem>
    </MenuList>
  );
}

export default MenuFamily;
